import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/Service/auth.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { UserService } from 'src/app/User/Service/user.service';

@Component({
    selector: 'app-team',
    templateUrl: './team.component.html',
    styleUrls: ['./../landing/landing.component.css', './team.component.css'],
    standalone: false
})
export class TeamComponent implements OnInit {

  @ViewChild('pricing') pricing;
  @ViewChild('teampopup') teampopup;
  currentTeamMember: any = [];
  constructor(
    public auth: AuthService,
    public userService: UserService,
    private loader: LoadingService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.loader.HideLoading();
  }

  showPricing() {
    this.modalService.open(this.pricing, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }
  showTeamPopUp(teamMember) {
    this.currentTeamMember = teamMember;
    this.modalService.open(this.teampopup, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }
  onClose() {
    this.modalService.dismissAll();
  }

  TeamMembersData = [
    {
      image: "/assets/images/David-Abramson.webp",
      mobileImage: "/assets/images/David-Abramson-mbl.webp",
      name: "David Abramson",
      description: "Concept Development and Compliance",
      information: ["David is a Principal in SDA Ventures LLC, a firm that advises emerging growth, middle-market companies and multinational companies primarily in health and wellness, food ingredients and food service business sectors on corporate development, business acquisition, customer relationships, growth strategies and corporate finance.",
        "David is an Executive Chairman of the Board for PanTheryx Inc., and serves as a Senior Advisor and Board member of Noblegen Inc. and Persona Nutrition.",
        "From 2003 to 2011, David served as the president of Martek Biosciences Corporation (NASDAQ: MATK), Martek is a leader in the innovation, production and sale of high-value products from microbial sources, including its flagship brand, life’s DHA™. This company was sold to DSM in 2010 for more than $1.0 billion.",
        "David played a leadership role in the ultimate sale of U.S. Foodservice to Royal Ahold, N.V. for a price in excess of $4.0 billion. David received a Juris Doctor Degree, with honors, from the University of Maryland School of Law in 1978, and he is a member of the Maryland Bar."]
    },
    {
      image: "/assets/images/Bob-Barton.webp",
      mobileImage: "/assets/images/Bob-Barton-mbl.webp",
      name: "Bob Barton",
      description: "Business Development and Financial Compliance",
      information: ["Bob was the 13th employee at drugstore.com where he served for nine years in various executive roles, including interim CEO, VP of Pharmacy, and six years as CFO. During this time period, he grew the publicly traded business to over $400M in sales.",
        "Following drugstore.com Bob joined Cranium where he drove, negotiated and executed the sale of the company to Hasbro. During the transaction process, Bob helped the company improve operational and bottom-line performance by an order of magnitude.",
        "Previously, Bob was the president of OnlineShoes.com where he drove significant top line growth of the middle market e-commerce company while expanding profitability and cash flow, and in July 2014 he executed the sale of the company.",
        "Bob also served as the CFO of MOD Pizza where he led the finance and technology teams of the fastest growing restaurant chain in the U.S. During his tenure, MOD opened 360 new stores, grew annual system-wide sales by $400 million, created more than 8,000 new jobs, and raised over $280 million in capital."
      ]
    },
    {
      image: "/assets/images/Dr-Mark-Freeman.webp",
      mobileImage: "/assets/images/Dr-Mark-Freeman-mbl.webp",
      name: "Dr. Mark Freeman",
      description: "Customer Development and User Interaction Testing",
      information: ["Dr. Freeman is a senior organization development, behavioral consultant and executive coach primarily working in the small business, academic, hospitality and healthcare industries. His expertise in the area of performance improvement includes change management, fundraising consulting, organizational training and development for management, business development, and executive leadership coaching.",
        "Dr. Freeman holds two licenses, one in mental health counseling and the other in marriage and family therapy from the State of Florida.  He is a nationally certified counselor and approved clinical supervisor."]
    },
    {
      image: "/assets/images/Jason-bio.webp",
      mobileImage: "/assets/images/Jason-bio-mbl.png",
      name: "Jason Brown",
      description: "Co-Founder and CEO",
      information: ["Jason has been creating teams and building direct to consumer companies for over four decades.  He lives in Florida with his wife, daughter, and son.  While a career entrepreneur, Jason has worked with several fortune 500 companies helping to scale operations to help millions of lives over the years.  Jason & Prem’s last company, Persona Nutrition, was a personalized nutrition company that was built from inception and scaled. They then partnered with Nestle Health Science so that they could grow the company to the global opportunity it is now. Together, Jason & Prem founded Family Central because they needed the tools to live a less anxious life and, simply put, to be able to safely store and communicate what matters to us for generations to come."]
    },
    {
      image: "/assets/images/Prem-bio.webp",
      mobileImage: "/assets/images/Prem-bio-mbl.png",
      name: "Prem Thudia",
      description: "Co-Founder and CTO",
      information: ["Prem is a career technology entrepreneur.  He has worked with fortune 500 companies prior to joining with Jason in 1999 to create their first of five companies together.  Prem lives in Hyderabad, India with his extended multi-generational family and wife Sheila, a busy pediatric eye surgeon who donates 50% of her time to help teach doctors around the globe. Prem has built technology and development teams to scale our companies as they grow.  He proudly still runs the technology for Persona Nutrition and has been instrumental in scaling that technology to a global enterprise.  Managing teams and being part of large family drive home the importance of properly being organized as a businessman, husband, godfather, and son."]
    },
    {
      image: "/assets/images/scott-slatin.webp",
      mobileImage: "/assets/images/Scott-Slatin-mbl.webp",
      name: "Scott Slatin",
      description: "Chief of Consumer Acquisition",
      information: ["Scott Slatin is a media professional with extensive expertise in interactive advertising, website design and optimization. He founded and runs a small agency – Rivington Media – that provides companies with media strategies to achieve their revenue goals.  Clients include numerous online publishers, major pharmaceutical brands, e-commerce sites and online subscription products.", "Before starting his own business, Scott managed marketing efforts for a number of online start-ups, where he focused on delivering profitable search, display and social media strategies. Mr. Slatin holds a BA in Economics from Vassar College and lives in New York and Fort Lauderdale, FL."]
    },
    {
      image: "/assets/images/Andrea-D-Martin.webp",
      mobileImage: "/assets/images/Andrea-D-Martin-mbl.webp",
      name: "Andrea D. Martin",
      description: "PR and Brand Development",
      information: ["Andrea Martin is a senior-level communications professional with more than 18 years of experience creating and executing integrated communications programs for B2B, B2C, and nonprofit organizations. Skilled in both brand and corporate communications, she has a proven track record of creating engaging public relations programs that achieve business goals and move people to action.",
        "Her experience spans technology, health, nutrition, legal services, travel and tourism, and education. One of the defining moments in her career is being a part of the launch team for the startup Persona Nutrition brand and seeing it successfully acquired by Nestlé."]
    },
    {
      image: "/assets/images/Seth-Eastman.webp",
      mobileImage: "/assets/images/Seth-Eastman-mbl.webp",
      name: "Seth Eastman",
      description: "Sr. Director of Research and Development",
      information: ["Seth graduated from University of Wyoming with a Bachelor of Science in Biology. Shortly after graduation he opened a company that focused on humanely capturing and releasing birds that get trapped inside grocery stores. That venture took him all over the Western United States where he operated primarily out of Washington State. He then took his passion for wellness and signed on with Persona Nutrition in a Quality Assurance and Project Manager role where he developed many skills in the workplace."]
    },
    {
      image: "/assets/images/Luis-de-la-Fuente.webp",
      mobileImage: "/assets/images/Luis-de-la-Fuente-mbl.webp",
      name: "Luis de la Fuente",
      description: "VP Business Development",
      information: ["Luis is an entrepreneur and business professional from Dallas, Texas. He earned his BS in Electrical Engineering from UT Dallas and an MBA from Southern Methodist University.",
        "He has 7 years experience developing companies in real estate, hospitality, and is now parlaying his MBA Venture Capital experience to help Family Central grow its customer base, partnerships and market influence."]
    },
    {
      image: "/assets/images/Merdith-Kish.webp",
      mobileImage: "/assets/images/Merdith-Kish-mbl.webp",
      name: "Meredith Kish",
      description: "PR and Integrated Marketing",
      information: ["Meredith Kish is a seasoned marketing communications professional with expertise in business development, affiliate marketing, and public relations. She is passionate about creating communication plans that incorporate strategic partnerships, dynamic external communications, and engaging content that build company awareness and drive consideration with key stakeholders. With nearly 20 years of experience, Meredith has worked primarily in parenting, technology, health/wellness and retail spaces. Meredith graduated from Purdue University, is happily married and is a mom of two young kids."]
    },
    {
      image: "/assets/images/Alison-Briggs.webp",
      mobileImage: "/assets/images/Alison-Briggs-mbl.webp",
      name: "Alison Briggs",
      description: "Executive Assistant",
      information: ["Alison is an administrative professional with more than a decade of experience serving and supporting executives in senior roles. Her experience spans across many business sectors including media, banking, and education. She works closely with the Founder and CEO of Family Central as a project manager companywide and maintains daily activities.",
       "Alison has a Bachelor’s degree in Communications & Psychology from the University of Pittsburgh. In her free time, she and her husband enjoy hiking and being outdoors. Alison, in dedication to her married life, has moved several times from state to state to support her husband’s career in the armed forces. He is now stationed at the Pentagon and a member of the newly developed Space Force as a Guardian."]
    },
    {
      image: "/assets/images/Krishn-Kumar.webp",
      mobileImage: "/assets/images/Krishn-mbl.webp",
      name: "Krishn Kumar",
      description: "VP Project Management",
      information: ["Krishn excels in Project Planning & execution from scope management, requirements analysis, resource deployment, scheduling, QA and tracking suitable metrics for Projects in Agile (Scrum) & Waterfall Project Management Methodologies. He is certified in PMP, CSM, SAFe Agilest etc."]
    },
    {
      image: "/assets/images/Srikanth-Dodla.webp",
      mobileImage: "/assets/images/Srikanth-mbl.webp",
      name: "Srikanth Dodla",
      description: "VP Technology",
      information: ["Srikanth is a Microsoft Certified Azure solution architect with 18+ years of experience driving digital solutions and information management strategy . Strategized, designed, and deployed innovative and complete application and security architecture for cloud data protection for Fortune 500 companies. He has an expertise in Solution Architecture, Application Development, Data Engineering, Release and Code Management."]
    },
    {
      image: "/assets/images/Viraj-Pratapwant.webp",
      mobileImage: "/assets/images/Viraj-mbl.webp",
      name: "Viraj Pratapwant",
      description: "Mobile Application Developer",
      information: ["Viraj is a Mobile App Developer. He is working with Family Central to build an app for Android and iOS platforms. His focus areas are architecture, develop and maintain apps. He also takes care of release management of the apps."]
    },
    {
      image: "/assets/images/Sunil-Kumar.webp",
      mobileImage: "/assets/images/Sunil-mbl.webp",
      name: "Sunil Kumar",
      description: "Chief Information Security Officer",
      information: ["Sunil is an IT executive and management consultant with more than 17 years of experience. He previously worked with 2 of the Big 4s (Deloitte and PWC), Bug 25-50 firms (such as Protiviti) and several IT multinationals and Fortune 50-500 firms globally.",
       "He has hands on experience in formulating Cyber Security Strategy, IT Governance Risk and Compliance Framework, Digital Transformation led projects, programs and portfolios for global clients."]
    },
    {
      image: "/assets/images/Mrudula-Kasibhatta.webp",
      mobileImage: "/assets/images/Mrudula-mbl.webp",
      name: "Mrudula Kasibhatta",
      description: "Project Manager",
      information: ["Mrudula is an administrate professional, with a varied experience in business sectors of e-commerce, education, and lead generation. Currently, she works closely with the co-founder and CTO of Family Central supporting him in daily activities and as a project manager.",
       "Mrudula has a bachelor’s degree in Commerce. She enjoys reading and finding creative expression through writing and painting in free time."]
    },
    {
      image: "/assets/images/Bulbul-MD-Hasan.webp",
      mobileImage: "/assets/images/Bulbul.webp",
      name: "Md. Bulbul Hasan",
      description: "Senior Front-end Developer",
      information: ["Bulbul is an innovative Front End Developer with 10+ years of experience in building and maintaining responsive websites in the recruiting industry.", 
      "Proficient in HTML, CSS, jQuery, JavaScript, and WordPress; plus modern libraries and frameworks. Passionate about usability and possess working knowledge of Adobe Photoshop, XD, Figma & Sketch."]
    },
    {
        image: "/assets/images/Eshwar-Bogoju.webp",
        mobileImage: "/assets/images/Eshwar.webp",
        name: "Eshwara Chary Bogoju",
        description: "Lead Graphic Designer",
        information: ["Eshwar is a creative and versatile designer with 10+ years of experience in creating beautiful & functional products with delightful digital and cross platform experiences.",
         "He is currently working with Family Central to create best in class, industry standard, aesthetically stunning user interfaces, applying high standards of usability, heuristics & user centered approach in design, keeping the business goal intact."]
    },
    {
        image: "/assets/images/Jyothi-Somaram.webp",
        mobileImage: "/assets/images/Jyothi.webp",
        name: "Jyothi Somaram",
        description: "Graphic Designer",
        information: ["Jyothi is a graphic designer with a passion for creative design and visual art. She enjoys creating a wide range of graphics and layouts for product illustrations, and websites while ensuring brand consistency throughout various marketing projects.",
         "She currently plays a major role in designing and management of the complete design process from conceptualization to delivery for Family Central."]
    }
  ]

  AdvisoryBoardMembers = [
    {
      image:"/assets/images/David-Abramson-family-pic.png",
      name:"David Abramson ",
      info:"(and his family)",
      description:"Concept Development and Compliance"
    },
    {
     image:"/assets/images/Bob-Barton-family-pic.webp",
     name:"Bob Barton ",
     info:"(and his family)",
     description:"Business Development and Financial Compliance"
    },
    {
      image:"/assets/images/Dr-Mark-Freeman-family-pic.webp",
      name:"Dr. Mark Freeman ",
      info:"(and his family)",
      description:"Customer Development and User Interaction Testing"
     }
  ];

  FoundingTeamMembers=[
    {
      image:"/assets/images/Jason-Family.webp",
      name:"Jason Brown ",
      info:"(and his family)",
      description:"Co-Founder and CEO"
    },
    {
      image:"/assets/images/Prem-Family.webp",
      name:"Prem Thudia ",
      info:"(and his family)",
      description:"Co-Founder and CTO"
    },
    {
      image:"/assets/images/Scott-Slatin-and-Dad.webp",
      name:"Scott Slatin ",
      info:"(and his family)",
      description:"Chief of Consumer Acquisition"
    },
    {
      image:"/assets/images/Andrea-Martin-family-pic.webp",
      name:"Andrea Martin ",
      info:"(and her family)",
      description:"Co-Founder and Brand Development"
    },
    {
      image:"/assets/images/Seth-Eastman-family-pic.webp",
      name:"Seth Eastman ",
      info:"(and his family)",
      description:"Sr. Director of Research and Development"
    },
    {
      image:"/assets/images/Luis-de-la-Fuente-family-pic.webp",
      name:"Luis de la Fuente ",
      info:"(and his family)",
      description:"VP Business Development"
    },
    {
      image:"/assets/images/Meredith-Kish-family-pic.webp",
      name:"Meredith Kish ",
      info:"(and her family)",
      description:"PR and Integrated Marketing"
    },
    {
      image:"/assets/images/Alison-Briggs-family-pic.webp",
      name:"Alison Briggs",
      info:"(and her family)",
      description:"Executive Assistant"
    }
  ];

  DevelopmentTeamMembers=[
    {
      image:"/assets/images/Krishn.webp",
      name:"Krishn Kumar",
      description:"VP Project Management"
    },
    {
      image:"/assets/images/Srikanth.webp",
      name:"Srikanth Dodla",
      description:"VP Technology"
    },
    {
      image:"/assets/images/Viraj.webp",
      name:"Viraj Pratapwant",
      description:"Mobile Application Developer"
    },
    {
      image:"/assets/images/Sunil.webp",
      name:"Sunil Kumar",
      description:"Chief Information Security Officer"
    },
    {
      image:"/assets/images/Mrudula.webp",
      name:"Mrudula Kasibhatta",
      description:"Project Manager"
    },
    {
      image:"/assets/images/Bulbul.webp",
      name:"Md. Bulbul Hasan",
      description:"Senior Front-end Developer"
    },
    {
        image:"/assets/images/Eshwar.webp",
        name:"Eshwara Chary Bogoju",
        description:"Lead Graphic Designer"
    },
    {
        image:"/assets/images/Jyothi.webp",
        name:"Jyothi Somaram",
        description:"Graphic Designer"
    }
    
  ]

}

